import React, { useRef, useCallback, useMemo } from 'react';
import { AgendaList, CalendarProvider, NewCalendarList } from 'react-native-calendars';
import { getTheme, themeColor } from '@/components/calendar/theme';
import { getMarkedDates, mapJobDateCrewListForFrontend } from '@/components/calendar/types';
import JobDateItem from '@/components/calendar/job-date-item';
import { trpc } from '@/trpc/react';
import { useCrew } from '@/context/CrewProvider';
import { Drawer } from 'expo-router/drawer';
import { DrawerToggleButton } from '@react-navigation/drawer';



interface Props {
  weekView?: boolean;
}

const ExpandableCalendarScreen = (props: Props) => {
  const { weekView } = props;
  const theme = useRef(getTheme());
  const todayBtnTheme = useRef({
    todayButtonTextColor: themeColor
  });

  const { currentCrewMember } = useCrew();

  const [jobDates] = trpc.jobDateListRouter.listForCrew.useSuspenseQuery({ id: currentCrewMember!.id, states: [2, 3] });


  const mappedJobDates = useMemo(() => {
    if (!jobDates?.data) {
      return [];
    }

    const isFlatRate = currentCrewMember?.crew_levels?.[0]?.level?.can_provide_feedback === true;
    return mapJobDateCrewListForFrontend(jobDates.data, currentCrewMember?.id || 0, [], { isFlatRate });
  }, [jobDates?.data, currentCrewMember?.id, currentCrewMember?.crew_levels])

  // const marked = useMemo(() => {
  //   return getMarkedDates(mappedJobDates);
  // }, [mappedJobDates])


  const renderItem = useCallback(({ item }: any) => {
    return <JobDateItem item={item} />;
  }, []);

  return (
    <>
      <Drawer.Screen
        options={{
          drawerLabel: 'Calendar',
          title: 'Calendar',
          headerLeft: () => <DrawerToggleButton />
        }}
      />
      <CalendarProvider
        date={new Date().toISOString().split('T')[0]}
        // onDateChanged={onDateChanged}
        // onMonthChange={onMonthChange}
        // showTodayButton
        // disabledOpacity={0.6}
        theme={todayBtnTheme.current}
      // todayBottomMargin={16}
      // todayButtonStyle={styles.todayButton}
      >

        <NewCalendarList           // testID={testIDs.expandableCalendar.CONTAINER}
        />

        {mappedJobDates.length ? (
          <AgendaList
            sections={mappedJobDates}
            renderItem={renderItem}
            // scrollToNextEvent
            className='bg-neutral-50 text-stone-600 capitalize'
            dayFormat={'dd MMM yyyy'}
            scrollToNextEvent
            markToday
          />
        ) : null}
      </CalendarProvider>
    </>
  );
};

export default ExpandableCalendarScreen;